import { Maturity } from "../DomainEvents.fs.js";
import { isEmpty, toArray, empty, cons, map as map_1, singleton, choose, append, filter, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Fa_i, Fa_IconOption } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useFeliz_React__React_useProgressStatus_Static, useFeliz_React__React_useDashboardCategory_Static, useFeliz_React__React_useDateRange_Static, useFeliz_React__React_useAttributes_Static, useFeliz_React__React_useMaturity_Static, useFeliz_React__React_useTypedParams_Static } from "../hooks/UseRouter.fs.js";
import { Helpers_combineClasses, Helpers_extractClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { unwrap, toArray as toArray_1, defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC, DomainEntity__get_Detail, DomainEntity__get_Name, ActivityDateRange, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F, SearchParams } from "../ClientTypes.fs.js";
import { EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString, System_Double__Double_ToLocaleString, Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDoHours, System_Int32__Int32_ToLocaleString, EPM_Domain_Events_Action_Category__Category_ToProperString, Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDo, EPM_Domain_Events_Maturity__Maturity_ToUrlString, EPM_Domain_Events_Maturity__Maturity_ToProperString, EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5 } from "../Prelude.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { collect, map as map_3, iterate, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { MaturitySelector_allMaturity } from "../components/Components.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { interpolate, toText, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FetchFail__get_Message, useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { attributes as attributes_1 } from "../Api/Tags.fs.js";
import { Modal_ModalWithFooter } from "../Modals/Modal.fs.js";
import { SelectOption, SelectItem, selectSearch_options_113CE11B, selectSearch_filterOptions_Z7A2530AD } from "../fable_modules/Feliz.SelectSearch.3.1.0/SelectSearch.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.SelectSearch.3.1.0/../Feliz.2.9.0/Interop.fs.js";
import react_select_search from "react-select-search";
import { Interop_defaultProps } from "../fable_modules/Feliz.SelectSearch.3.1.0/./SelectSearch.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { toString as toString_1, fromDateTimeOffset } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { parse } from "../fable_modules/Feliz.2.9.0/./DateParsing.fs.js";
import { fromDate } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { LoadingBar, NoData } from "../Assets.fs.js";
import { map as map_2 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi as reactApi_2 } from "../Bindings/Nivo/../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ResponsivePie } from "@nivo/pie";
import { totalHours } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { single } from "../Api/Entities.fs.js";
import { FSharpMap__Change } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { FSharpSet__get_IsEmpty, empty as empty_2, remove as remove_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { useProjectStatsByDate, useProjectStats } from "./Data.fs.js";
import { Totals } from "./Totals.fs.js";
import { SCurve } from "./SCurve.fs.js";
import { CalendarHeatMap } from "./CalendarHeatMap.fs.js";
import { Breakdown } from "./Breakdown.fs.js";
import "./Dashboard.scss";


const allMaturity = ofArray([undefined, new Maturity(3, []), new Maturity(2, []), new Maturity(1, []), new Maturity(4, []), new Maturity(5, []), new Maturity(6, [])]);

function maturityIcon(maturityOpt) {
    if (maturityOpt != null) {
        const maturity = maturityOpt;
        switch (maturity.tag) {
            case 3:
                return new Fa_IconOption(11, ["fas fa-wrench"]);
            case 4:
                return new Fa_IconOption(11, ["fas fa-vial"]);
            case 6:
                return new Fa_IconOption(11, ["far fa-handshake"]);
            case 2:
                return new Fa_IconOption(11, ["fas fa-cogs"]);
            case 1:
                return new Fa_IconOption(11, ["fas fa-highlighter"]);
            case 0:
                return new Fa_IconOption(11, ["fas fa-question"]);
            default:
                return new Fa_IconOption(11, ["fas fa-magic"]);
        }
    }
    else {
        return new Fa_IconOption(11, ["fas fa-bars"]);
    }
}

function MaturityPhase() {
    let elems, elems_1;
    const currentParams = useFeliz_React__React_useTypedParams_Static();
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        const v = ev.target.value;
        let newParams;
        const list_3 = filter((p) => {
            if (p.tag === 9) {
                return false;
            }
            else {
                return true;
            }
        }, currentParams);
        newParams = append(choose((x_1) => x_1, singleton(map((Item) => (new SearchParams(9, [Item])), EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5(v)))), list_3);
        const href = Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(newParams, true);
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(newParams, true);
    }], ["defaultValue", defaultArg(map(toString, useFeliz_React__React_useMaturity_Static()), "")], (elems = toList(delay(() => append_1(singleton_1(createElement("option", {
        children: "Maturity: All",
        value: "",
    })), delay(() => map_1((maturity_1) => createElement("option", {
        children: EPM_Domain_Events_Maturity__Maturity_ToProperString(maturity_1),
        value: EPM_Domain_Events_Maturity__Maturity_ToUrlString(maturity_1),
    }), MaturitySelector_allMaturity))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function AttributeModal(attributeModalInputProps) {
    let fetchedAttributes, inputProperties, handler;
    const close = attributeModalInputProps.close;
    const projectId = attributeModalInputProps.projectId;
    const searchParams = useFeliz_React__React_useTypedParams_Static();
    const initialAttributes = useFeliz_React__React_useAttributes_Static();
    const patternInput = reactApi.useState(initialAttributes);
    const attributes = patternInput[0];
    const fetchedAttributesOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((tagParams) => attributes_1(projectId, tagParams), empty(), [projectId]));
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: (fetchedAttributesOpt != null) ? ((fetchedAttributes = fetchedAttributesOpt, (inputProperties = createObj(ofArray([["placeholder", "Select Attribute"], ["value", toArray(attributes)], ["search", true], ["multiple", true], ["closeOnSelect", false], ["printOptions", "on-focus"], selectSearch_filterOptions_Z7A2530AD((item, searchQuery) => (item.value.toLocaleLowerCase().indexOf(searchQuery.trim().toLocaleLowerCase()) >= 0)), (handler = patternInput[1], ["onChange", (values) => {
            if (Array.isArray(values)) {
                handler(ofArray(values));
            }
            else {
                handler(singleton(values));
            }
        }]), selectSearch_options_113CE11B(toList(delay(() => map_1((attribute) => (new SelectOption(0, [new SelectItem(attribute, attribute, false)])), fetchedAttributes))))])), reactApi_1.createElement(react_select_search, Object.assign({}, Interop_defaultProps, inputProperties))))) : defaultOf(),
        disabled: false,
        footer: ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Set"], ["onClick", (_arg) => {
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(append(singleton(new SearchParams(13, [attributes])), filter((p) => {
                if (p.tag === 13) {
                    return false;
                }
                else {
                    return true;
                }
            }, searchParams)), true);
            close();
        }]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Clear"], ["className", "is-warning"], ["onClick", (_arg_1) => {
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(filter((p_1) => {
                if (p_1.tag === 13) {
                    return false;
                }
                else {
                    return true;
                }
            }, searchParams), true);
            close();
        }]]))))]),
        title: "Choose Attributes",
    });
}

function DateRangeModal(dateRangeModalInputProps) {
    let endDate_2, startDate_2, endDate_3, startDate_3, endDate_1, startDate_1, onDate_2, onDate_3, onDate_1;
    const close = dateRangeModalInputProps.close;
    const searchParams = useFeliz_React__React_useTypedParams_Static();
    const initialDateRange = useFeliz_React__React_useDateRange_Static();
    let patternInput;
    if (initialDateRange != null) {
        const dateRange = initialDateRange;
        patternInput = ((dateRange.tag === 0) ? ["on", "completed", undefined, undefined, fromDateTimeOffset(dateRange.fields[0], 0)] : ((dateRange.tag === 3) ? ["between", "planned", fromDateTimeOffset(dateRange.fields[0], 0), fromDateTimeOffset(dateRange.fields[1], 0), undefined] : ((dateRange.tag === 2) ? ["on", "planned", undefined, undefined, fromDateTimeOffset(dateRange.fields[0], 0)] : ((dateRange.tag === 4) ? ["between", "any", fromDateTimeOffset(dateRange.fields[0], 0), fromDateTimeOffset(dateRange.fields[1], 0), undefined] : ((dateRange.tag === 5) ? ["on", "any", undefined, undefined, fromDateTimeOffset(dateRange.fields[0], 0)] : ["between", "completed", fromDateTimeOffset(dateRange.fields[0], 0), fromDateTimeOffset(dateRange.fields[1], 0), undefined])))));
    }
    else {
        patternInput = ["between", "any", undefined, undefined, undefined];
    }
    const startDate = patternInput[2];
    const onDate = patternInput[4];
    const endDate = patternInput[3];
    const patternInput_1 = reactApi.useState(patternInput[0]);
    const setDateRangeType = patternInput_1[1];
    const dateRangeType = patternInput_1[0];
    const patternInput_2 = reactApi.useState(patternInput[1]);
    const setActivityRangeType = patternInput_2[1];
    const activityRangeType = patternInput_2[0];
    const patternInput_3 = reactApi.useState(startDate);
    const startDateOpt = patternInput_3[0];
    const patternInput_4 = reactApi.useState(endDate);
    const endDateOpt = patternInput_4[0];
    const patternInput_5 = reactApi.useState(onDate);
    const onDateOpt = patternInput_5[0];
    const isBetween = dateRangeType === "between";
    const isOn = dateRangeType === "on";
    const isPlanned = activityRangeType === "planned";
    const isCompleted = activityRangeType === "completed";
    const isAny = activityRangeType === "any";
    let content;
    const xs_59 = toList(delay(() => {
        let elems_5, children_4, elms_3, elms_2, elms, elms_1;
        return append_1(singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-horizontal"], (elems_5 = [createElement("div", {
            className: "field-label",
            children: "Date Range",
        }), (children_4 = singleton((elms_3 = singleton((elms_2 = ofArray([(elms = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "date-range"], ["checked", isBetween], ["defaultValue", "between"], ["onChange", (ev) => {
            if (ev.target.checked) {
                setDateRangeType("between");
            }
        }]]))))), createElement("span", {
            className: "",
            children: "Between",
        })]), createElement("label", {
            className: "radio",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "date-range"], ["checked", isOn], ["defaultValue", "on"], ["onChange", (ev_1) => {
            if (ev_1.target.checked) {
                setDateRangeType("on");
            }
        }]]))))), createElement("span", {
            className: "",
            children: "On",
        })]), createElement("label", {
            className: "radio",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))]), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))), createElement("div", {
            className: "field-body",
            children: reactApi.Children.toArray(Array.from(children_4)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))), delay(() => {
            let elems_12, children_11, elms_8, elms_7, elms_4, elms_5, elms_6;
            return append_1(singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-horizontal"], (elems_12 = [createElement("div", {
                className: "field-label",
                children: "Activity Range",
            }), (children_11 = singleton((elms_8 = singleton((elms_7 = ofArray([(elms_4 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "activity-range"], ["checked", isPlanned], ["value", "planned"], ["onChange", (ev_2) => {
                if (ev_2.target.checked) {
                    setActivityRangeType("planned");
                }
            }]]))))), createElement("span", {
                className: "",
                children: "Planned",
            })]), createElement("label", {
                className: "radio",
                children: reactApi.Children.toArray(Array.from(elms_4)),
            })), (elms_5 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "activity-range"], ["checked", isCompleted], ["value", "completed"], ["onChange", (ev_3) => {
                if (ev_3.target.checked) {
                    setActivityRangeType("completed");
                }
            }]]))))), createElement("span", {
                className: "",
                children: "Actual",
            })]), createElement("label", {
                className: "radio",
                children: reactApi.Children.toArray(Array.from(elms_5)),
            })), (elms_6 = ofArray([createElement("input", createObj(cons(["type", "radio"], Helpers_combineClasses("radio", ofArray([["name", "activity-range"], ["checked", isAny], ["value", "any"], ["onChange", (ev_4) => {
                if (ev_4.target.checked) {
                    setActivityRangeType("any");
                }
            }]]))))), createElement("span", {
                className: "",
                children: "Any",
            })]), createElement("label", {
                className: "radio",
                children: reactApi.Children.toArray(Array.from(elms_6)),
            }))]), createElement("div", {
                className: "control",
                children: reactApi.Children.toArray(Array.from(elms_7)),
            }))), createElement("div", {
                className: "field",
                children: reactApi.Children.toArray(Array.from(elms_8)),
            }))), createElement("div", {
                className: "field-body",
                children: reactApi.Children.toArray(Array.from(children_11)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))))), delay(() => {
                let elems_18, children_17, elms_10, elems_15, children_14, elms_9;
                return (dateRangeType === "between") ? append_1(singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-horizontal"], (elems_18 = [createElement("div", {
                    className: "field-label",
                    children: "From",
                }), (children_17 = singleton((elms_10 = singleton(createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", createElement("input", createObj(cons(["type", "date"], Helpers_combineClasses("input", toList(delay(() => {
                    let matchValue_2, value_152;
                    return append_1((matchValue_2 = startDate, (matchValue_2 != null) ? singleton_1((value_152 = matchValue_2, ["value", toString_1(value_152, "yyyy-MM-dd")])) : (empty_1())), delay(() => singleton_1(["onChange", (ev_6) => {
                        iterate((arg_1) => {
                            patternInput_3[1](arg_1);
                        }, toArray_1(parse(ev_6.target.value)));
                    }])));
                }))))))]]))))), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms_10)),
                }))), createElement("div", {
                    className: "field-body",
                    children: reactApi.Children.toArray(Array.from(children_17)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_18))])]))))), delay(() => {
                    let elems_21, children_20, elms_11;
                    return singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-horizontal"], (elems_21 = [createElement("div", {
                        className: "field-label",
                        children: "To",
                    }), (children_20 = singleton((elms_11 = singleton(createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", createElement("input", createObj(cons(["type", "date"], Helpers_combineClasses("input", toList(delay(() => {
                        let matchValue_3, value_178;
                        return append_1((matchValue_3 = endDate, (matchValue_3 != null) ? singleton_1((value_178 = matchValue_3, ["value", toString_1(value_178, "yyyy-MM-dd")])) : (empty_1())), delay(() => singleton_1(["onChange", (ev_7) => {
                            iterate((arg_2) => {
                                patternInput_4[1](arg_2);
                            }, toArray_1(parse(ev_7.target.value)));
                        }])));
                    }))))))]]))))), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_11)),
                    }))), createElement("div", {
                        className: "field-body",
                        children: reactApi.Children.toArray(Array.from(children_20)),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_21))])])))));
                })) : singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-horizontal"], (elems_15 = [createElement("div", {
                    className: "field-label",
                    children: "On",
                }), (children_14 = singleton((elms_9 = singleton(createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", createElement("input", createObj(cons(["type", "date"], Helpers_combineClasses("input", toList(delay(() => {
                    let matchValue_1, value_126;
                    return append_1((matchValue_1 = onDate, (matchValue_1 != null) ? singleton_1((value_126 = matchValue_1, ["value", toString_1(value_126, "yyyy-MM-dd")])) : (empty_1())), delay(() => singleton_1(["onChange", (ev_5) => {
                        iterate((arg) => {
                            patternInput_5[1](arg);
                        }, toArray_1(parse(ev_5.target.value)));
                    }])));
                }))))))]]))))), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms_9)),
                }))), createElement("div", {
                    className: "field-body",
                    children: reactApi.Children.toArray(Array.from(children_14)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))));
            }));
        }));
    }));
    content = react.createElement(react.Fragment, {}, ...xs_59);
    const validDateRange = (dateRangeType === "between") ? ((activityRangeType === "completed") ? ((startDateOpt != null) ? ((endDateOpt != null) ? ((onDateOpt == null) ? ((endDate_2 = endDateOpt, (startDate_2 = startDateOpt, new ActivityDateRange(1, [fromDate(startDate_2), fromDate(endDate_2)])))) : undefined) : undefined) : undefined) : ((activityRangeType === "any") ? ((startDateOpt != null) ? ((endDateOpt != null) ? ((onDateOpt == null) ? ((endDate_3 = endDateOpt, (startDate_3 = startDateOpt, new ActivityDateRange(4, [fromDate(startDate_3), fromDate(endDate_3)])))) : undefined) : undefined) : undefined) : ((startDateOpt != null) ? ((endDateOpt != null) ? ((onDateOpt == null) ? ((endDate_1 = endDateOpt, (startDate_1 = startDateOpt, new ActivityDateRange(3, [fromDate(startDate_1), fromDate(endDate_1)])))) : undefined) : undefined) : undefined))) : ((activityRangeType === "completed") ? ((startDateOpt == null) ? ((endDateOpt == null) ? ((onDateOpt != null) ? ((onDate_2 = onDateOpt, new ActivityDateRange(0, [fromDate(onDate_2)]))) : undefined) : undefined) : undefined) : ((activityRangeType === "any") ? ((startDateOpt == null) ? ((endDateOpt == null) ? ((onDateOpt != null) ? ((onDate_3 = onDateOpt, new ActivityDateRange(5, [fromDate(onDate_3)]))) : undefined) : undefined) : undefined) : ((startDateOpt == null) ? ((endDateOpt == null) ? ((onDateOpt != null) ? ((onDate_1 = onDateOpt, new ActivityDateRange(2, [fromDate(onDate_1)]))) : undefined) : undefined) : undefined)));
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: content,
        disabled: false,
        footer: ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Set"], ["disabled", validDateRange == null], ["onClick", (_arg) => {
            let list_3;
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F((list_3 = filter((p) => {
                if (p.tag === 12) {
                    return false;
                }
                else {
                    return true;
                }
            }, searchParams), append(choose((x_3) => x_3, singleton(map((Item) => (new SearchParams(12, [Item])), validDateRange))), list_3)), true);
            close();
        }]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Clear"], ["className", "is-warning"], ["onClick", (_arg_1) => {
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(filter((p_1) => {
                if (p_1.tag === 12) {
                    return false;
                }
                else {
                    return true;
                }
            }, searchParams), true);
            close();
        }]]))))]),
        title: "Choose Date Range",
    });
}

function DashboardOptions(dashboardOptionsInputProps) {
    let elems_8;
    const projectId = dashboardOptionsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setModal = patternInput[1];
    const dateRangeOpt = useFeliz_React__React_useDateRange_Static();
    const close = () => {
        setModal(undefined);
    };
    return createElement("nav", createObj(Helpers_combineClasses("level", ofArray([op_PlusPlus(["className", "is-mobile"], ["className", "is-scrollable"]), ["className", "dashboard-options"], (elems_8 = toList(delay(() => {
        let elms_2, elms, elems, elms_1, elems_2;
        return append_1(singleton_1((elms_2 = ofArray([createElement(MaturityPhase, null), (elms = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg) => {
            setModal("attributes");
        }], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", Fa_i(singleton(new Fa_IconOption(11, ["fas fa-ellipsis-h"])), [])]])))), createElement("span", {
            className: "is-hidden-mobile",
            children: "Attributes",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))), createElement("div", {
            className: "level-item",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg_1) => {
            setModal("dateRange");
        }], (elems_2 = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", Fa_i(singleton(new Fa_IconOption(11, ["fas fa-calendar-alt"])), [])]])))), createElement("span", createObj(toList(delay(() => append_1(singleton_1(["className", "is-hidden-mobile"]), delay(() => {
            const matchValue = dateRangeOpt;
            if (matchValue != null) {
                const matchValue_1 = matchValue;
                return (matchValue_1.tag === 3) ? singleton_1(["children", `Planned: ${toString_1(matchValue_1.fields[0], "d")} → ${toString_1(matchValue_1.fields[1], "d")}`]) : ((matchValue_1.tag === 4) ? singleton_1(["children", `${toString_1(matchValue_1.fields[0], "d")} → ${toString_1(matchValue_1.fields[1], "d")}`]) : ((matchValue_1.tag === 0) ? singleton_1(["children", `Actual: ${toString_1(matchValue_1.fields[0], "d")}`]) : ((matchValue_1.tag === 2) ? singleton_1(["children", `Planned: ${toString_1(matchValue_1.fields[0], "d")}`]) : ((matchValue_1.tag === 5) ? singleton_1(["children", `${toString_1(matchValue_1.fields[0], "d")}`]) : singleton_1(["children", `Actual: ${toString_1(matchValue_1.fields[0], "d")} → ${toString_1(matchValue_1.fields[1], "d")}`])))));
            }
            else {
                return singleton_1(["children", "All"]);
            }
        }))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), createElement("div", {
            className: "level-item",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))]), createElement("div", {
            className: "level-left",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))), delay(() => {
            let elms_4, elms_3, elems_5;
            return append_1(singleton_1((elms_4 = singleton((elms_3 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg_2) => {
                Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(0, ["scopeOfWork"])), true, true);
            }], (elems_5 = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", Fa_i(singleton(new Fa_IconOption(11, ["fas fa-undo"])), [])]])))), createElement("span", {
                className: "is-hidden-mobile",
                children: "Reset",
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))), createElement("div", {
                className: "level-item",
                children: reactApi.Children.toArray(Array.from(elms_3)),
            }))), createElement("div", {
                className: "level-right",
                children: reactApi.Children.toArray(Array.from(elms_4)),
            }))), delay(() => {
                const matchValue_2 = patternInput[0];
                if (matchValue_2 != null) {
                    const modal = matchValue_2;
                    return (modal === "dateRange") ? singleton_1(createElement(DateRangeModal, {
                        close: close,
                    })) : singleton_1(createElement(AttributeModal, {
                        projectId: projectId,
                        close: close,
                    }));
                }
                else {
                    return singleton_1(defaultOf());
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
}

function ActivityChart(stats) {
    const dashboardCategoryOpt = useFeliz_React__React_useDashboardCategory_Static();
    const progressStatus = useFeliz_React__React_useProgressStatus_Static();
    const typedParams = useFeliz_React__React_useTypedParams_Static();
    const pieData = [{
        id: "Behind",
        label: "Behind",
        progress: "behind",
        value: stats.Behind,
    }, {
        id: "To Do",
        label: "Left To Do",
        progress: "toDo",
        value: Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDo(stats) - stats.Behind,
    }, {
        id: "Completed",
        label: "Actual",
        progress: "completed",
        value: stats.Completed,
    }];
    const isBehind = stats.Completed < stats.Planned;
    const plannedPercent = (stats.Total === 0) ? 0 : ((stats.Planned / stats.Total) * 100);
    const completedPercent = (stats.Total === 0) ? 0 : ((stats.Completed / stats.Total) * 100);
    const toDoPercent = (stats.Total === 0) ? 0 : ((Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDo(stats) / stats.Total) * 100);
    const behindPercent = (stats.Total === 0) ? 0 : ((stats.Behind / stats.Total) * 100);
    let onClick;
    const dependencies_1 = [typedParams];
    onClick = reactApi.useCallback((progressOpt) => ((_arg) => {
        let list_3;
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F((list_3 = filter((p) => {
            if (p.tag === 10) {
                return false;
            }
            else {
                return true;
            }
        }, typedParams), append(choose((x) => x, singleton(map((Item) => (new SearchParams(10, [Item])), progressOpt))), list_3)), true);
    }), dependencies_1);
    const xs_12 = toList(delay(() => {
        let children_12, children_4, children_2;
        return append_1(singleton_1(createElement("div", {
            className: "data",
            children: createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], ["className", "is-hoverable"], ["children", (children_12 = ofArray([createElement("tr", createObj(toList(delay(() => append_1(equals(progressStatus, undefined) ? singleton_1(op_PlusPlus(["className", "is-selected"], ["className", "is-clickable"])) : singleton_1(["className", "is-clickable"]), delay(() => {
                let clo;
                return append_1(singleton_1(["onClick", (clo = onClick(undefined), (arg_1) => {
                    clo(arg_1);
                })]), delay(() => {
                    let elems, children;
                    return singleton_1((elems = [(children = singleton(createElement("strong", {
                        children: [defaultArg(map(EPM_Domain_Events_Action_Category__Category_ToProperString, dashboardCategoryOpt), "All")],
                    })), createElement("td", {
                        children: reactApi.Children.toArray(Array.from(children)),
                    })), createElement("td", {
                        children: [System_Int32__Int32_ToLocaleString(stats.Total)],
                    }), createElement("td", {})], ["children", reactApi.Children.toArray(Array.from(elems))]));
                }));
            })))))), (children_4 = ofArray([createElement("td", {
                children: ["Planned"],
            }), createElement("td", {
                children: [System_Int32__Int32_ToLocaleString(stats.Planned)],
            }), (children_2 = singleton(createElement("small", {
                children: [toText(interpolate("%.2f%P()%%", [plannedPercent]))],
            })), createElement("td", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            }))]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), createElement("tr", createObj(toList(delay(() => append_1(equals(progressStatus, "completed") ? singleton_1(op_PlusPlus(["className", "is-selected"], ["className", "is-clickable"])) : singleton_1(["className", "is-clickable"]), delay(() => {
                let clo_1;
                return append_1(singleton_1(["onClick", (clo_1 = onClick("completed"), (arg_3) => {
                    clo_1(arg_3);
                })]), delay(() => {
                    let elems_1, children_6;
                    return singleton_1((elems_1 = [createElement("td", {
                        children: ["Actual"],
                    }), createElement("td", {
                        children: [System_Int32__Int32_ToLocaleString(stats.Completed)],
                    }), (children_6 = singleton(createElement("small", createObj(toList(delay(() => append_1(singleton_1(["children", toText(interpolate("%.2f%P()%%", [completedPercent]))]), delay(() => (isBehind ? singleton_1(["className", "has-text-danger"]) : singleton_1(["className", "has-text-success"]))))))))), createElement("td", {
                        children: reactApi.Children.toArray(Array.from(children_6)),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
                }));
            })))))), createElement("tr", createObj(toList(delay(() => append_1(equals(progressStatus, "toDo") ? singleton_1(op_PlusPlus(["className", "is-selected"], ["className", "is-clickable"])) : singleton_1(["className", "is-clickable"]), delay(() => {
                let clo_2;
                return append_1(singleton_1(["onClick", (clo_2 = onClick("toDo"), (arg_5) => {
                    clo_2(arg_5);
                })]), delay(() => {
                    let elems_2, children_8;
                    return singleton_1((elems_2 = [createElement("td", {
                        children: ["To Do (inc behind)"],
                    }), createElement("td", {
                        children: [System_Int32__Int32_ToLocaleString(Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDo(stats))],
                    }), (children_8 = singleton(createElement("small", {
                        children: [toText(interpolate("%.2f%P()%%", [toDoPercent]))],
                    })), createElement("td", {
                        children: reactApi.Children.toArray(Array.from(children_8)),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
                }));
            })))))), createElement("tr", createObj(toList(delay(() => append_1(equals(progressStatus, "behind") ? singleton_1(op_PlusPlus(["className", "is-selected"], ["className", "is-clickable"])) : singleton_1(["className", "is-clickable"]), delay(() => {
                let clo_3;
                return append_1(singleton_1(["onClick", (clo_3 = onClick("behind"), (arg_7) => {
                    clo_3(arg_7);
                })]), delay(() => {
                    let elems_3, children_10;
                    return singleton_1((elems_3 = [createElement("td", {
                        children: ["Behind"],
                    }), createElement("td", {
                        children: [System_Int32__Int32_ToLocaleString(stats.Behind)],
                    }), (children_10 = singleton(createElement("small", createObj(toList(delay(() => append_1(singleton_1(["children", toText(interpolate("%.2f%P()%%", [behindPercent]))]), delay(() => ((stats.Behind > 0) ? singleton_1(["className", "has-text-danger"]) : empty_1())))))))), createElement("td", {
                        children: reactApi.Children.toArray(Array.from(children_10)),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
                }));
            }))))))]), createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_12)),
            }))]])))),
        })), delay(() => {
            let properties_10;
            return (stats.Total === 0) ? singleton_1(createElement("div", {
                className: "missing-data",
                children: NoData([]),
            })) : singleton_1(createElement("div", {
                className: "chart",
                children: (properties_10 = ofArray([["data", pieData], ["valueFormat", " >-,"], ["innerRadius", 0.5], ["padAngle", 4], ["colors", {
                    scheme: "pastel1",
                }], ["cornerRadius", 3], ["activeOuterRadiusOffset", 4], ["borderWidth", 1], ["margin", {
                    top: defaultArg(10, 0),
                    right: defaultArg(0, 0),
                    left: defaultArg(55, 0),
                    bottom: defaultArg(10, 0),
                }], ["borderColor", {
                    from: "color",
                    modifiers: [["darker", 0.2]],
                }], ["enableArcLabels", false], ["enableArcLinkLabels", false], ["theme", {
                    tooltip: {
                        container: {
                            background: "#333",
                        },
                    },
                }], ["legends", map_2(createObj, [ofArray([["direction", "column"], ["anchor", "left"], ["justify", false], ["translateX", -50], ["translateY", 0], ["itemsSpacing", 5], ["itemWidth", 85], ["itemHeight", 20], ["itemTextColor", "#999"], ["itemDirection", "left-to-right"], ["itemOpacity", 1], ["symbolSize", 15], ["symbolShape", "square"]])])]]), reactApi_2.createElement(ResponsivePie, createObj(properties_10))),
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_12);
}

function HourChart(stats) {
    const pieData = [{
        id: "Over",
        label: "Over",
        value: totalHours(stats.OverageTime),
    }, {
        id: "To Do",
        label: "To Do + Over",
        value: totalHours(Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDoHours(stats) + stats.OverageTime),
    }, {
        id: "Completed",
        label: "Actual",
        value: totalHours(stats.ActualCompletionTime - stats.OverageTime),
    }];
    const xs_6 = toList(delay(() => {
        let elems, children_2, children, children_12, children_4, children_6, children_8, children_10;
        return append_1(singleton_1(createElement("div", {
            className: "data",
            children: createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], (elems = [(children_2 = singleton((children = singleton(createElement("td", {
                className: "has-text-centered",
                colSpan: 2,
                children: "Hours",
            })), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children)),
            }))), createElement("thead", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), (children_12 = ofArray([(children_4 = ofArray([createElement("td", {
                children: ["Planned"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(totalHours(stats.EstimatedCompletionTime))],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), (children_6 = ofArray([createElement("td", {
                children: ["Actual"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(totalHours(stats.ActualCompletionTime))],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_6)),
            })), (children_8 = ofArray([createElement("td", {
                children: ["To Do"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(totalHours(Types_Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown__ProjectBreakdown_get_ToDoHours(stats)))],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_8)),
            })), (children_10 = ofArray([createElement("td", {
                children: ["Overage"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(totalHours(stats.OverageTime))],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_10)),
            }))]), createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_12)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        })), delay(() => {
            let properties_4;
            return (totalHours(stats.EstimatedCompletionTime) === 0) ? singleton_1(createElement("div", {
                className: "missing-data",
                children: NoData([]),
            })) : singleton_1(createElement("div", {
                className: "chart",
                children: (properties_4 = ofArray([["data", pieData], ["valueFormat", " >-,"], ["innerRadius", 0.5], ["padAngle", 4], ["colors", {
                    scheme: "pastel1",
                }], ["cornerRadius", 3], ["activeOuterRadiusOffset", 4], ["borderWidth", 1], ["margin", {
                    top: defaultArg(10, 0),
                    right: defaultArg(0, 0),
                    left: defaultArg(55, 0),
                    bottom: defaultArg(10, 0),
                }], ["borderColor", {
                    from: "color",
                    modifiers: [["darker", 0.2]],
                }], ["enableArcLabels", false], ["enableArcLinkLabels", false], ["theme", {
                    tooltip: {
                        container: {
                            background: "#333",
                        },
                    },
                }], ["legends", map_2(createObj, [ofArray([["direction", "column"], ["anchor", "left"], ["justify", false], ["translateX", -50], ["translateY", 0], ["itemsSpacing", 5], ["itemWidth", 85], ["itemHeight", 20], ["itemTextColor", "#999"], ["itemDirection", "left-to-right"], ["itemOpacity", 1], ["symbolSize", 15], ["symbolShape", "square"]])])]]), reactApi_2.createElement(ResponsivePie, createObj(properties_4))),
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_6);
}

function AttributeChart(attributeChartInputProps) {
    const stats = attributeChartInputProps.stats;
    const attribute = attributeChartInputProps.attribute;
    const pieData = [{
        id: "Beind",
        label: "Beind",
        value: stats.Behind,
    }, {
        id: "To Do",
        label: "To Do",
        value: stats.Total - stats.Completed,
    }, {
        id: "Completed",
        label: "Actual",
        value: stats.Completed,
    }];
    const xs_6 = toList(delay(() => {
        let elems, children_2, children, children_12, children_4, children_6, children_8, children_10;
        return append_1(singleton_1(createElement("div", {
            className: "data",
            children: createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], (elems = [(children_2 = singleton((children = singleton(createElement("td", {
                className: "has-text-centered",
                colSpan: 2,
                children: attribute,
            })), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children)),
            }))), createElement("thead", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), (children_12 = ofArray([(children_4 = ofArray([createElement("td", {
                children: ["Planned"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(stats.Total)],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), (children_6 = ofArray([createElement("td", {
                children: ["Actual"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(stats.Completed)],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_6)),
            })), (children_8 = ofArray([createElement("td", {
                children: ["To Do"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(stats.Total - stats.Completed)],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_8)),
            })), (children_10 = ofArray([createElement("td", {
                children: ["Behind"],
            }), createElement("td", {
                children: [System_Double__Double_ToLocaleString(stats.Behind)],
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_10)),
            }))]), createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_12)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        })), delay(() => {
            let properties_4;
            return (stats.Total === 0) ? singleton_1(createElement("div", {
                className: "missing-data",
                children: NoData([]),
            })) : singleton_1(createElement("div", {
                className: "chart",
                children: (properties_4 = ofArray([["data", pieData], ["valueFormat", " >-,"], ["innerRadius", 0.5], ["padAngle", 4], ["colors", {
                    scheme: "pastel1",
                }], ["cornerRadius", 3], ["activeOuterRadiusOffset", 4], ["borderWidth", 1], ["margin", {
                    top: defaultArg(10, 0),
                    right: defaultArg(0, 0),
                    left: defaultArg(55, 0),
                    bottom: defaultArg(10, 0),
                }], ["borderColor", {
                    from: "color",
                    modifiers: [["darker", 0.2]],
                }], ["enableArcLabels", false], ["enableArcLinkLabels", false], ["theme", {
                    tooltip: {
                        container: {
                            background: "#333",
                        },
                    },
                }], ["legends", map_2(createObj, [ofArray([["direction", "column"], ["anchor", "left"], ["justify", false], ["translateX", -50], ["translateY", 0], ["itemsSpacing", 5], ["itemWidth", 85], ["itemHeight", 20], ["itemTextColor", "#999"], ["itemDirection", "left-to-right"], ["itemOpacity", 1], ["symbolSize", 15], ["symbolShape", "square"]])])]]), reactApi_2.createElement(ResponsivePie, createObj(properties_4))),
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_6);
}

function statBox(content) {
    return createElement("div", createObj(Helpers_combineClasses("box", ofArray([["className", join(" ", ["project-stat", "m-2", "p-2"])], ["children", content]]))));
}

function ProjectStatsBreakdown(projectStatsBreakdownInputProps) {
    let elems;
    const projectStatsOpt = projectStatsBreakdownInputProps.projectStatsOpt;
    return createElement("div", createObj(ofArray([["className", join(" ", ["project-stats", "mb-4"])], (elems = toList(delay(() => {
        let matchValue;
        return append_1((matchValue = projectStatsOpt, (matchValue != null) ? singleton_1(statBox(createElement(ActivityChart, matchValue))) : singleton_1(statBox(LoadingBar([])))), delay(() => {
            let matchValue_1;
            return append_1((matchValue_1 = projectStatsOpt, (matchValue_1 != null) ? singleton_1(statBox(createElement(HourChart, matchValue_1))) : singleton_1(statBox(LoadingBar([])))), delay(() => {
                const matchValue_2 = projectStatsOpt;
                return (matchValue_2 != null) ? map_3((att) => statBox(createElement(AttributeChart, {
                    attribute: att[0],
                    stats: att[1],
                })), matchValue_2.AttributeCount) : singleton_1(defaultOf());
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function WhereAmIEntityTag(whereAmIEntityTagInputProps) {
    let elems;
    const remove = whereAmIEntityTagInputProps.remove;
    const entityId = whereAmIEntityTagInputProps.entityId;
    const domainEntity = whereAmIEntityTagInputProps.domainEntity;
    const projectId = whereAmIEntityTagInputProps.projectId;
    const fetched = useFeliz_React__React_useFetch_Static_6ADA66EC((entityId_1) => single(domainEntity, projectId, entityId_1), entityId, [entityId]);
    const elms = singleton(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(domainEntity)]])))), createElement("span", createObj(Helpers_combineClasses("tag", toList(delay(() => ((fetched.tag === 0) ? singleton_1(["className", "is-primary"]) : ((fetched.tag === 1) ? append_1(singleton_1(["className", "is-primary"]), delay(() => append_1(singleton_1(["children", "..."]), delay(() => singleton_1(["title", "loading"]))))) : ((fetched.tag === 3) ? append_1(singleton_1(["className", "is-danger"]), delay(() => append_1(singleton_1(["children", "⁉️"]), delay(() => singleton_1(["title", FetchFail__get_Message(fetched.fields[0])]))))) : append_1(singleton_1(["className", "is-primary"]), delay(() => {
        const matchValue = fetched.fields[0];
        if (matchValue == null) {
            return append_1(singleton_1(["children", "?"]), delay(() => singleton_1(["title", "Unknown"])));
        }
        else {
            const entity = matchValue;
            return append_1(singleton_1(["children", DomainEntity__get_Name(entity)]), delay(() => singleton_1(["title", defaultArg(DomainEntity__get_Detail(entity), "")])));
        }
    })))))))))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-delete"], ["className", "is-clickable"], ["onClick", (_arg) => {
        remove();
    }]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
    return createElement("div", {
        className: "control",
        children: reactApi.Children.toArray(Array.from(elms)),
    });
}

function WhereAmITag(whereAmITagInputProps) {
    let elems;
    const remove = whereAmITagInputProps.remove;
    const value = whereAmITagInputProps.value;
    const header = whereAmITagInputProps.header;
    const elms = singleton(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", header]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], ["children", value]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-delete"], ["className", "is-clickable"], ["onClick", (_arg) => {
        remove();
    }]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
    return createElement("div", {
        className: "control",
        children: reactApi.Children.toArray(Array.from(elms)),
    });
}

function WhereAmILabelsTag(whereAmILabelsTagInputProps) {
    const labels = whereAmILabelsTagInputProps.labels;
    const domainEntity = whereAmILabelsTagInputProps.domainEntity;
    const xs_9 = collect((label) => map_3((value_2) => {
        let elems;
        const elms = singleton(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", label[0]], ["title", `${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(domainEntity)} label`]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], ["children", value_2]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-delete"], ["className", "is-clickable"], ["onClick", (_arg) => {
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(5, [domainEntity, FSharpMap__Change(labels, label[0], (v) => {
                const newSet = remove_1(value_2, defaultArg(v, empty_2({
                    Compare: comparePrimitives,
                })));
                return FSharpSet__get_IsEmpty(newSet) ? undefined : newSet;
            })])), false);
        }]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
        return createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        });
    }, label[1]), labels);
    return react.createElement(react.Fragment, {}, ...xs_9);
}

function WhereAmI(whereAmIInputProps) {
    let elems_1;
    const projectId = whereAmIInputProps.projectId;
    const tags = choose((tp) => {
        const remove = () => {
            Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC(singleton(tp));
        };
        switch (tp.tag) {
            case 2:
                return createElement(WhereAmIEntityTag, {
                    projectId: projectId,
                    domainEntity: tp.fields[1],
                    entityId: tp.fields[0],
                    remove: remove,
                });
            case 7:
                return createElement(WhereAmITag, {
                    header: "Condition",
                    value: toString(tp.fields[0]),
                    remove: remove,
                });
            case 8:
                return createElement(WhereAmITag, {
                    header: "Criticality",
                    value: toString(tp.fields[0]),
                    remove: remove,
                });
            case 6:
                return createElement(WhereAmITag, {
                    header: "Status",
                    value: toString(tp.fields[0]),
                    remove: remove,
                });
            case 1:
                return createElement(WhereAmITag, {
                    header: "Search",
                    value: tp.fields[0],
                    remove: remove,
                });
            case 5:
                return createElement(WhereAmILabelsTag, {
                    domainEntity: tp.fields[0],
                    labels: tp.fields[1],
                });
            default:
                return undefined;
        }
    }, useFeliz_React__React_useTypedParams_Static());
    if (isEmpty(tags)) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-black"], (elems_1 = [createElement("h2", {
            className: "subtitle",
            children: "Dashboard View",
        }), createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", reactApi.Children.toArray(Array.from(tags))]]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    }
}

export function Dashboard(dashboardInputProps) {
    let elems_3, elems, elems_2, elems_1;
    const projectId = dashboardInputProps.projectId;
    const projectStatsOpt = useProjectStats(projectId);
    const statsByDate = useProjectStatsByDate(projectId);
    return createElement("section", createObj(ofArray([["className", "dashboard"], (elems_3 = [createElement("div", createObj(ofArray([["className", "has-background-black-bis"], (elems = [createElement(DashboardOptions, {
        projectId: projectId,
    }), createElement(WhereAmI, {
        projectId: projectId,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Totals, {
        projectId: projectId,
    }), createElement(ProjectStatsBreakdown, {
        projectStatsOpt: unwrap(projectStatsOpt),
    }), createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "is-ancestor"], ["className", "mx-4"], (elems_2 = [createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "is-vertical"], ["className", "is-parent"], ["className", "is-8"], (elems_1 = [createElement(SCurve, {
        dataOpt: unwrap(statsByDate),
    }), createElement(CalendarHeatMap, {
        dataOpt: unwrap(statsByDate),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "is-parent"], ["className", "breakdown"], ["children", createElement(Breakdown, {
        projectId: projectId,
    })]]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

